mutation RecalculateDafAdminFees {
  recalculateDafAdminFees(input: {}) {
    success
  }
}
